import React, { forwardRef } from 'react';
import { unlockAudio } from '../audio/sfxCore.js';
import { useBoardSize } from '../hooks/useBoardSize.js';
import { FloatingItem } from './FloatingItem.jsx';
import { GameBackground } from './GameBackground.jsx';
import { PopBurst } from './PopBurst.jsx';
import { ScoreFloater } from './ScoreFloater.jsx';

export const GameBoard = forwardRef(function GameBoard(
    {
        state,
        t,
        onItemClick,
        bursts = [],
        floaters = [],
        hideHint = false,
        boardShake = false,
        boardFlash = false,
        introGoPulse = false,
    },
    ref,
) {
    const boardSize = useBoardSize(ref);

    const boardClassName = [
        'lp-game__board',
        boardShake && 'lp-game__board--shake',
        boardFlash && 'lp-game__board--flash',
        introGoPulse && 'lp-game__board--go-pulse',
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <div className={boardClassName} ref={ref} onPointerDown={unlockAudio}>
            <GameBackground />

            {!hideHint ? <div className="lp-game__hint">{t('game.hint')}</div> : null}

            {boardFlash ? <div className="lp-game__board-flash" aria-hidden /> : null}

            {floaters.map((floater) => (
                <ScoreFloater key={floater.id} floater={floater} boardSize={boardSize} />
            ))}

            {bursts.map((burst) => (
                <PopBurst key={burst.id} burst={burst} t={t} boardSize={boardSize} />
            ))}

            {state.items.map((item) => (
                <FloatingItem
                    key={item.id}
                    item={item}
                    boardSize={boardSize}
                    t={t}
                    onItemClick={onItemClick}
                />
            ))}
        </div>
    );
});
